import * as React from 'react'
import { Box, IconButton } from '@mui/material'
import { AddBoxSharp, IndeterminateCheckBox } from '@mui/icons-material'

const COLOR_POPUP = 'var(--color-primary)'
const COLOR_RED = 'red'
const COLOR_WHITE = '#fffafa'
const COLOR_BORDER = '#e3e7ea'

const BTStyle = add => ({
  p: 0,
  width: '30px',
  height: '30px',
  color: COLOR_WHITE,
  borderRadius: 'inherit',
  backgroundColor: COLOR_POPUP,
  border: `1px solid ${COLOR_BORDER}`,
  '&:hover': {
    backgroundColor: COLOR_WHITE,
    color: add ? COLOR_POPUP : COLOR_RED,
    opacity: add ? 0.9 : 0.7,
  },
  '&:active': {
    backgroundColor: COLOR_WHITE,
    color: add ? COLOR_POPUP : COLOR_RED,
    opacity: 0.9,
  },
})

const FilterButton = ({ add = false, onClick, pl }) => {
  return (
    <Box sx={{ pl, alignSelf: 'center' }}>
      <IconButton
        onClick={onClick}
        aria-label={add ? 'addnewfilter' : 'removefilter'}
        size="small"
        sx={BTStyle(add)}>
        {add ? (
          <AddBoxSharp fontSize="large" />
        ) : (
          <IndeterminateCheckBox fontSize="large" />
        )}
      </IconButton>
    </Box>
  )
}

export default FilterButton
